module.exports = __webpack_public_path__ + "static/media/arenisca.7efbc20f.jpg";